import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";

export default function TreatmentControl({ apiUrl = "/api/ncd/treatment-control" }) {
	const [data, setData] = useState(null);
	useEffect(() => {
		let mounted = true;
		(async () => {
			try {
				const res = await fetch(apiUrl, { cache: 'no-store' });
				if (!res.ok) throw new Error();
				const json = await res.json();
				if (!mounted) return;
				setData(json);
			} catch {
				setData({ controlled_htn_pct: 68, uncontrolled_htn_pct: 32, controlled_dm_pct: 61, uncontrolled_dm_pct: 39, followup_compliance: 78 });
			}
		})();
		return () => mounted = false;
	}, [apiUrl]);

	const htnData = { labels: ["Controlled", "Uncontrolled"], datasets: [{ data: [data?.controlled_htn_pct || 0, data?.uncontrolled_htn_pct || 0], backgroundColor: ["#2dce89", "#fb6340"] }] };
	const dmData = { labels: ["Controlled", "Uncontrolled"], datasets: [{ data: [data?.controlled_dm_pct || 0, data?.uncontrolled_dm_pct || 0], backgroundColor: ["#2dce89", "#fb6340"] }] };

	return (
		<div className="d-flex gap-2 mt-3">
			<div className="col-6">
				<div className="card shadow-sm border-0 h-100">
					<div className="card-body p-2">
						<h6 className="text-gray-800 font-semibold fs-6 mb-2">HTN Controlled vs Uncontrolled</h6>
						<div style={{ height: 160 }}><Doughnut data={htnData} options={{ maintainAspectRatio: false, responsive: true, plugins: { legend: { position: 'bottom' } } }} /></div>
					</div>
				</div>
			</div>
			<div className="col-6">
				<div className="card shadow-sm border-0 h-100">
					<div className="card-body p-2">
						<h6 className="text-gray-800 font-semibold fs-6 mb-2">DM Controlled vs Uncontrolled</h6>
						<div style={{ height: 160 }}><Doughnut data={dmData} options={{ maintainAspectRatio: false, responsive: true, plugins: { legend: { position: 'bottom' } } }} /></div>
						<div className="mt-2 fs-6 text-muted">Follow-up compliance: {data?.followup_compliance || 0}%</div>
					</div>
				</div>
			</div>
		</div>
	);
}
